<div class="student-transcript">
    <div *ngIf="loading" class="text-center py-5">
        <i class="fa-solid fa-spinner fa-spin"></i> Loading transcript...
    </div>

    <div *ngIf="!loading && transcriptData">
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h4 class="mb-0"><strong>TRANSCRIPT</strong></h4>
            <button class="btn btn-primary" (click)="printTranscript()">
                <i class="fa-solid fa-print"></i> Print PDF
            </button>
        </div>

        <!-- Student Info Section -->
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="form-group">
                    <label><strong>Name of the Candidate</strong></label>
                    <p>{{transcriptData.student?.name || 'N/A'}}</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label><strong>Class commencement (Induction Day) Date</strong></label>
                    <p>{{transcriptData.batch?.start_year || 'N/A'}}</p>
                </div>
            </div>
        </div>

        <!-- Academic Details Section -->
        <h5 class="mb-3 text-center"><strong>ACADEMIC DETAILS</strong></h5>

        <div class="table-responsive"
            *ngIf="transcriptData.academic_details && transcriptData.academic_details.length > 0; else noAcademicData">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th rowspan="2">Sl. No</th>
                        <th rowspan="2">Subjects</th>
                        <th colspan="2" class="text-center">Theory Hours</th>
                        <th colspan="2" class="text-center">Practical Hours</th>
                    </tr>
                    <tr>
                        <th>Prescribed</th>
                        <th>Attended</th>
                        <th>Prescribed</th>
                        <th>Attended</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let year of transcriptData.academic_details; let yearIndex = index">
                        <!-- Year Header Row -->
                        <tr>
                            <td colspan="6" class="font-weight-bold bg-light">{{year.semester_name}}</td>
                        </tr>
                        <!-- Subject Rows -->
                        <ng-container *ngIf="year.subjects && year.subjects.length > 0; else noSubjects">
                            <tr *ngFor="let subject of year.subjects; let i = index">
                                <td>{{i + 1}}</td>
                                <td>{{subject.name}}</td>
                                <td class="text-center">{{subject.theory_prescribed || 0}}</td>
                                <td class="text-center">{{subject.theory_attended || 0}}</td>
                                <td class="text-center">{{subject.practical_prescribed || 0}}</td>
                                <td class="text-center">{{subject.practical_attended || 0}}</td>
                            </tr>
                        </ng-container>
                        <ng-template #noSubjects>
                            <tr>
                                <td colspan="6" class="text-center text-muted">No subjects found for this year</td>
                            </tr>
                        </ng-template>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Exam Details Section -->
        <h5 class="mb-3 text-center mt-5"><strong>EXAM DETAILS</strong></h5>

        <div class="table-responsive"
            *ngIf="transcriptData.academic_details && transcriptData.academic_details.length > 0">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th rowspan="2">Sl No</th>
                        <th rowspan="2">Subject</th>
                        <th>Marks Awarded</th>
                        <th>Passing Minimum</th>
                        <th>Maximum Marks</th>
                        <th>Month and Year of Passing</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let year of transcriptData.academic_details">
                        <!-- Year Header Row -->
                        <tr>
                            <td colspan="6" class="font-weight-bold bg-light">{{year.semester_name}}</td>
                        </tr>
                        <!-- Subject Rows -->
                        <ng-container *ngIf="year.subjects && year.subjects.length > 0">
                            <tr *ngFor="let subject of year.subjects; let i = index">
                                <td>{{i + 1}}</td>
                                <td>{{subject.name}}</td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="subject.marks_awarded"
                                        (blur)="saveExamDetails(subject)" placeholder="Marks">
                                </td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="subject.passing_minimum"
                                        (blur)="saveExamDetails(subject)" placeholder="Min">
                                </td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="subject.maximum_marks"
                                        (blur)="saveExamDetails(subject)" placeholder="Max">
                                </td>
                                <td>
                                    <input type="text" class="form-control" [(ngModel)]="subject.month_year_passing"
                                        (blur)="saveExamDetails(subject)" placeholder="Month/Year">
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <ng-template #noAcademicData>
            <div class="alert alert-info">
                No academic details available for this student.
            </div>
        </ng-template>
    </div>

    <div *ngIf="!loading && !transcriptData" class="alert alert-info">
        No transcript data available for this student.
    </div>
</div>